var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M12 17.4c-2.844 0-5.147-2.201-5.359-4.991l-3.934-3.04c-.517.648-.993 1.334-1.377 2.084-.174.344-.174.75 0 1.095C3.364 16.516 7.39 19.2 12 19.2c1.01 0 1.983-.15 2.92-.392l-1.945-1.506A5.408 5.408 0 0112 17.4zm11.768 2.179l-4.145-3.204a12.412 12.412 0 003.046-3.828c.174-.344.174-.75 0-1.094C20.636 7.485 16.61 4.8 12 4.8c-1.93.002-3.83.489-5.524 1.414l-4.77-3.687a.599.599 0 00-.842.105l-.737.948a.599.599 0 00.106.841l22.063 17.053a.6.6 0 00.842-.105l.737-.948a.6.6 0 00-.106-.842zm-6.89-5.325l-1.473-1.14a3.554 3.554 0 00-4.354-4.572c.226.307.348.677.349 1.058a1.754 1.754 0 01-.058.375l-2.76-2.133A5.325 5.325 0 0112 6.6a5.397 5.397 0 015.4 5.394V12a5.27 5.27 0 01-.521 2.254z"
  }))));
}

export default SvgEyeSlash;